import React, { useContext } from 'react';
import { useDispatch } from "react-redux";
import { useI18N } from "../../../../../my-puratos/hoc/withI18N";
import { getDoc } from "../../../../../../api/ECOM/getDoc.api";
import { isLoggedIn } from "../../../../../../data/user.model";
import { ProductContext } from "../../../../../pages/ProductStencil";
import { redirectToLogin } from "../../../../../../actions/auth";
import { isTDSDocType } from "../common";

export const Ingredients = ({ downloads = [] }) => {
    const translate = useI18N();
    const { product } = useContext(ProductContext) || {};
    const downloadAssets = product?.downloadAssets || [];
    const authorContent = product?.ingredientsAllergensUsage;
    const isTDS = isTDSDocType(downloads);
    const isNoData = (!downloads?.length && !authorContent && !downloadAssets?.length);
    const dispatch = useDispatch();

    const handleClick = async (event, URLId, name) => {
        event.preventDefault();
        if (isLoggedIn()) {
            await getDoc(URLId, name);
            return;
        };
        dispatch(redirectToLogin());
    }

    const showDownloads = downloads?.length > 0;
    const showDownloadAssets = downloadAssets?.length > 0;

    return (
        <div className={`${isNoData ? 'accordion__ingredients no-data' : 'accordion__ingredients'}`}>
            {(!isTDS && authorContent) &&
                <div className={"accordion__ingredients--author"} dangerouslySetInnerHTML={{ __html: authorContent }} />
            }
            {(showDownloads || showDownloadAssets) && (
                <div className={"accordion__ingredients--downloads"}>
                    <p>{translate('Downloads')}</p>
                    {showDownloads && downloads.map(({ ProductName, URLId }, index) => (
                        <a onClick={(e) => handleClick(e, URLId, ProductName)} href="#" key={index}>
                            <div className={"download-icon"} />
                            {ProductName}
                        </a>
                    ))}
                    {showDownloadAssets && downloadAssets.map((URL, index) => {
                        const fileName = URL?.split('/').pop().replace('.pdf', '');
                        return (
                            <a href={URL} key={index}>
                                <div className={"download-icon"} />
                                {fileName}
                            </a>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
